/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'download': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M961.147 448.535c-35.417 0-64.076 28.69-64.076 64.075v384.464H128.15V512.61c0-35.385-28.656-64.075-64.076-64.075-35.417 0-64.078 28.69-64.078 64.075v448.537c0 35.386 28.659 64.076 64.078 64.076h897.074c35.422 0 64.076-28.688 64.076-64.076V512.61c0-35.385-28.654-64.075-64.076-64.075zm-384.459 0V56.245c0-31.063-28.658-56.25-64.078-56.25-35.417 0-64.075 25.187-64.075 56.25v392.29H256.303L512.61 704.84l256.308-256.305h-192.23z"/>'
  }
})
